import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import CubbySlot from '../CubbySlot/index';
import CubbyChecksList from '../CubbyCheckList/index';
import style from './cubby.module.scss';

const Cubby = props => {
  const [rowArray, setRowArray] = useState([]);
  const [colArray, setColArray] = useState([]);
  const [overlay, setOverlay] = useState({
    show: false,
    slotId: null,
  });
  const actionRef = useRef(null);
  const iconRef = useRef(null);
  const {
    getCheckListItem,
    ascendingCheck,
    checksForAssignment,
    onSelecteCheckForAssignment,
    handleExpandedRightSection,
    pickedUp,
    storeInfo,
    deviceGroup,
    twoDimensionSlot,
    onSlotAssign,
    handleShowCheckDetails,
    searchFieldValue,
    setSearchFieldValue,
    setSelectedCheck,
    clearSlot,
    setPopup,
    checkSortFunc,
  } = props;
  const { storeCubby } = storeInfo || {};
  const { rowCount, columnCount } = storeCubby || {};

  useEffect(() => {
    function handleClickOutside(event) {
      if (!overlay.show) return;

      const clickedInsideOverlay =
        actionRef.current && actionRef.current.contains(event.target);

      const clickedMoreIcon =
        iconRef.current && iconRef.current.contains(event.target);

      if (!clickedInsideOverlay && !clickedMoreIcon) {
        setOverlay({ show: false, slotId: null });
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [overlay]);

  useEffect(() => {
    setRowArray(
      Array.from({ length: rowCount }, (_, rowIndex) => ({
        id: `row-${rowIndex}`,
      }))
    );
  }, [rowCount]);

  useEffect(() => {
    setColArray(
      Array.from({ length: columnCount }, (_, colIndex) => ({
        id: `col-${colIndex}`,
      }))
    );
  }, [columnCount]);

  const isRowScrolling = rowCount > 6;
  const isColumnScrolling = columnCount > 10;

  return (
    <div className="w-100 h-100 row mx-0">
      <div
        className={cn(
          'col-lg-2 col-md-3 col-3 pl-0 h-100',
          style.cubbyContainerPR
        )}
      >
        <CubbyChecksList
          checklist={getCheckListItem}
          ascendingCheck={ascendingCheck}
          checksForAssignment={checksForAssignment}
          onSelecteCheckForAssignment={onSelecteCheckForAssignment}
          handleShowCheckDetails={handleShowCheckDetails}
          searchFieldValue={searchFieldValue}
          setSearchFieldValue={setSearchFieldValue}
          checkSortFunc={checkSortFunc}
        />
      </div>
      <div
        className={cn(
          'col-lg-10 col-md-9 col-9 pr-0 h-100',
          style.cubbyContainerPL
        )}
      >
        <div className={cn('w-100 h-100 p-2', style.cubbySlotContainer)}>
          <div
            className={cn(
              'w-100 h-100',
              style.cubbySlotWrapper,
              isColumnScrolling && 'overflowX',
              isRowScrolling && 'overflowY'
            )}
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
              gridTemplateRows: `repeat(${rowCount}, 1fr)`,
              gap: '8px',
              width: '100%',
              height: '100%',
            }}
          >
            {rowArray.flatMap((_, rowIndex) =>
              colArray.map((_, colIndex) => (
                <CubbySlot
                  key={`${rowIndex}-${colIndex}`}
                  slot={twoDimensionSlot[rowIndex][colIndex]}
                  rowIndex={rowIndex}
                  colIndex={colIndex}
                  rowCount={rowCount}
                  columnCount={columnCount}
                  deviceGroup={deviceGroup}
                  onSlotAssign={onSlotAssign}
                  handleShowCheckDetails={handleShowCheckDetails}
                  handleExpandedRightSection={handleExpandedRightSection}
                  pickedUp={pickedUp}
                  setOverlay={setOverlay}
                  overlay={overlay}
                  actionRef={actionRef}
                  iconRef={iconRef}
                  setSelectedCheck={setSelectedCheck}
                  clearSlot={clearSlot}
                  setPopup={setPopup}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cubby;
